import classNames from 'classnames';
import { jsx as _jsx } from "react/jsx-runtime";
/**
 * For information about how and when to use this component,
 * [refer to its full documentation page](https://design.cms.gov/components/accordion/).
 */
export const Accordion = _ref => {
  let {
    bordered,
    children,
    className
  } = _ref;
  const classes = classNames('ds-c-accordion', bordered && 'ds-c-accordion--bordered', className);
  return /*#__PURE__*/_jsx("div", {
    className: classes,
    children: children
  });
};
export default Accordion;